
import angular from 'angular';
import TestimoniesComponent from './testimonies.component';

let TestimoniesModule = angular.module('home.testimonies',[])
.component('testimonies',TestimoniesComponent);
export default TestimoniesModule;



// WEBPACK FOOTER //
// ./www/components/shared/components/testimonies/testimonies.js